<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader :title="$t('projectsDeposits.projectsDepositsOperations')"
                     :description="$t('projectsDeposits.fromHereYouCanControlProjectsDepositsOperations')" />
        <indexTable :searchText="$t('projectsDeposits.searchForAnProjectsDepositsOperations')"
                    :emptyTableText="$t('projectsDeposits.thereAreNoProjectsDepositsOperations')"
                    :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
                    :buttonRole="$user.role.projects_deposits_add"
                    :statusSearch="true"
                    :statusValues="[
                      { title: $t('orders.situation'), value: ''},
                      { title: $t('orders.all'), value: ''},
                      { title: $t('invoices.draft'), value: 0 },
                      { title: $t('invoices.approved'), value: 1 },
                    ]"
                    :cloumns="[
                                  {column: 'code',    title: $t('projectsDeposits.operation') ,type: 'mainLink' , sort: true },
                                  {column: 'project_id',    title: $t('projectsDeposits.projectName'), type: 'link', to:'project', sort: true, link: true},
                                  {column: 'store_id',    title: $t('projectsDeposits.storeName'), type: 'link', to:'store', sort: true, link: true},
                                  {column: 'date',    title: $t('projectsDeposits.theDateOfTheOperation') ,type: 'text' , sort: true },
                                  {column: 'bill_id',    title: $t('projectsDeposits.bill') ,type: 'linkInvoice', to:'bill', sort: true, link: true},
                                  {column: 'total',    title: $t('projectsDeposits.Total') ,type: 'text' , sort: true },
                                  {column: 'description',    title: $t('projectsDeposits.thatIsAbout') ,type: 'text' , sort: true },
                                  {column: 'status', title: $t('bills.situation') ,type: 'status' , sort: true ,  values: [
                                        {title: $t('invoices.draft'), value: 0, color: 'dark'},
                                        {title: $t('invoices.approved'), value: 1, color: 'success'},
                                      ]
                                  },
                                  {column: 'options', title: $t('projectsDeposits.settings'), type: 'options', options: [
                                      {name: 'show'},
                                      {name: 'edit',   role: $user.admin || $user.role.projects_deposits_edit},
                                      {name: 'file'},
                                      {name: 'printProjectsDeposit',   role: true},
                                      {name: 'delete', role: $user.admin || $user.role.projects_deposits_delete},
                                  ]}
                                ]"
                    :deleteText="{
                                 attention: $t('allerts.Attention'),
                                 areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
                                 close: $t('allerts.close'),
                                 confirm: $t('allerts.confirm'),
                                 loading: $t('allerts.loading'),
                                }" />
      </div>
    </div>
  </div>
</template>
<script>

import indexHeader from "../elements/index/indexHeader.vue";
import indexTable from "../elements/index/indexTable.vue";

export default {
  data() {
    return {
      path: "/projectsDeposits"
    };
  },
  components: {
    indexHeader,
    indexTable,
  },
};
</script>
